import { Accordion, Spinner } from "react-bootstrap";

import { CustomToggle } from "../CustomToggle/CustomToggle";
import AmznFeeModule from "./AmznFee.module.scss";

import { toCustomString } from "src/common/util";

interface AmznFeeProps {
  /** 販売手数料（税抜）。patternId 不明時は undefined になり得る */
  referralFee: number | undefined;
  /** カテゴリ別成約料（税抜）。patternId 不明時は undefined になり得る */
  closingFee: number | undefined;
  /** 販売手数料 + カテゴリ別成約料の税込合計 */
  referralFeeIncTax: number | undefined;
  isLoading: boolean;
  hasError: boolean;
}

export const AmznFee: React.FC<AmznFeeProps> = ({
  referralFee,
  closingFee,
  referralFeeIncTax,
  isLoading,
  hasError,
}: AmznFeeProps) => {
  const renderTotal = (): JSX.Element => {
    if (hasError) {
      return <>---</>;
    }
    if (isLoading) {
      // ローディング中：直前の値をグレーアウト + スピナー表示
      return (
        <span style={{ opacity: 0.4 }}>
          ￥ {toCustomString(referralFeeIncTax)}{" "}
          <Spinner animation="border" size="sm" />
        </span>
      );
    }
    return <>￥ {toCustomString(referralFeeIncTax)}</>;
  };

  return (
    /** Amazon手数料 **/
    <div className={`${AmznFeeModule["amazon-fee-div"]} py-2`}>
      <Accordion className="my-auto">
        <div
          className={`${AmznFeeModule["amazon-fee-div2"]} d-flex justify-content-between`}
        >
          <div className="my-auto">
            <span>Amazon手数料</span>
            <CustomToggle eventKey="amazon-fee">詳細</CustomToggle>
          </div>
          <div className="px-2 my-auto">
            {renderTotal()}
            <small className={`${AmznFeeModule.small} text-muted`}>
              {" "}
              (税込)
            </small>
          </div>
        </div>
        <div>
          <Accordion.Collapse eventKey="amazon-fee">
            <div
              className={`${AmznFeeModule["acc-collpse"]} font-14 font-res-12 px-2 px-sm-3 py-1 py-sm-2 ms-2 ms-sm-4 my-1 my-sm-2`}
            >
              <div className="d-flex justify-content-between py-1">
                <span>販売手数料</span>
                <span>
                  ￥ {toCustomString(referralFee)}
                  <small className={`${AmznFeeModule.small} text-muted`}>
                    {" "}
                    (税抜)
                  </small>
                </span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>カテゴリー別成約料</span>
                <span>
                  ￥ {toCustomString(closingFee)}
                  <small className={`${AmznFeeModule.small} text-muted`}>
                    {" "}
                    (税抜)
                  </small>
                </span>
              </div>
            </div>
          </Accordion.Collapse>
        </div>
      </Accordion>
    </div>
  );
};
